export const GET_ANSWER_INBOX_PROCESS_STATEMENT_COUNT_FAILURE = 'GET_ANSWER_INBOX_PROCESS_STATEMENT_COUNT_ERROR';

export const getAnswerInboxProcessStatementCountFailure = ({ error, request }) => ({
    type: GET_ANSWER_INBOX_PROCESS_STATEMENT_COUNT_FAILURE,
    payload: error,
    error: true,
    meta: {
        request
    }
});